import Vue from "vue";
// import axios from "axios";

const state = {
	appliedFreebet: localStorage.getItem("btk-freebets")
		? JSON.parse(localStorage.getItem("btk-freebets"))
		: {},
	freeBets: [],
	fetchingFreebets: false,
	freebetAppliedStatus: localStorage.getItem("freebetStatus")
		? JSON.parse(localStorage.getItem("freebetStatus"))
		: false,
};

const persistFreebets = (freebets) => {
	localStorage.setItem("btk-freebets", JSON.stringify(freebets));
};

const persistFreebetApplied = (status) => {
	localStorage.setItem("freebetStatus", status);
};

const getDefaultFreebet = () => {
	return [];
};

const getters = {
	freebetFetchingStatus: (state) => {
		return state.fetchingFreebets;
	},
	allFreebets: (state) => {
		return state.freeBets ? state.freeBets : getDefaultFreebet();
	},
	appliedFreebet: (state) => {
		return state.appliedFreebet;
	},
	freebetAppliedStatus: (state) => {
		return state.freebetAppliedStatus;
	},
};

const mutations = {
	setFreebetFetchingStatus(state, status) {
		state.fetchingFreebets = status;
	},
	setFreebets(state, freeBets) {
		state.freeBets = freeBets;
	},
	setFreebetAppliedStatus(state, appliedStatus) {
		state.freebetAppliedStatus = appliedStatus;
		persistFreebetApplied(appliedStatus);
	},
	setAppliedFreebet(state, freebet) {
		state.appliedFreebet = freebet;
		persistFreebets(freebet);
	},
	removeFreebet(state, freebet) {
		let freebets = state.freebets ? state.freebets : getDefaultFreebets();
		freebets = freebets.filter((fb) => {
			return fb.free_bet_profile_id != freebet.free_bet_profile_id;
		});
		state.freebets = freebets;
		persistFreebets(freebets);
	},
};

const actions = {
	getFreebets({ commit, state }) {
		return new Promise((resolve, reject) => {
			let payload = {
				token: JSON.parse(localStorage.token),
			};
			commit("setFreebetFetchingStatus", true);
			Vue.http.post(`${FREE_BETS_API_URL}free-bets-profile`, payload).then(
				(response) => {
					console.log("[Freebets] Fetched freebets");
					if (response.data.length == 0 && state.freebetAppliedStatus) {
						commit("setAppliedFreebet", {});
						commit("setFreebetAppliedStatus", false);
					} else {
						commit("setFreebets", response.data);
					}
					commit("setFreebetFetchingStatus", false);
					resolve(response.data);
				},
				(error) => {
					commit("setFreebetFetchingStatus", false);
					reject(error);
				}
			);
		});
	},
	applyFreebet({ commit }, freebet) {
		commit("setAppliedFreebet", freebet);
		commit("setFreebetAppliedStatus", true);
	},
	removeAppliedFreebet({ commit }, freebet) {
		commit("setAppliedFreebet", freebet);
		commit("setFreebetAppliedStatus", false);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
